import { render } from "./DashboardKanbanView.vue?vue&type=template&id=d8799be0"
import script from "./DashboardKanbanView.vue?vue&type=script&lang=js"
export * from "./DashboardKanbanView.vue?vue&type=script&lang=js"

import "./DashboardKanbanView.vue?vue&type=style&index=0&id=d8799be0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__